import React from 'react';
import { string, bool, func } from 'prop-types';

import { Flex, Text } from '@olxbr/ds-web';

import {
  Container,
  DescriptionContainer,
  IconContainer,
} from './styles';

function CardTitle({
  title, Icon, description, disabled,
}) {
  return (
    <Container>
      <Flex alignItems="center" justifyContent="center">
        <IconContainer>
          <Icon width={21} height={32} color="white" />
        </IconContainer>
        <Text.TitleSmall>{title}</Text.TitleSmall>
      </Flex>
      <DescriptionContainer disabled={disabled}>{description}</DescriptionContainer>
    </Container>
  );
}

CardTitle.propTypes = {
  Icon: func.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  disabled: bool,
};

CardTitle.defaultProps = {
  disabled: false,
};

export default CardTitle;
